export default __webpack_public_path__ + "static/media/logo.6b75ca7e.png";